const products = [
    {
        id: "1",
        img: "/Images/Ourteam/team/31.jpg",
        Sname:"HARISH SHET",
        Sdesignation:"Project Lead",
        // calendly: "https://calendly.com/harish-orionmarineconcepts",
    },
    {
        id: "2",
        img: "/Images/Ourteam/team/12.jpg",
         Sname:"SHRISTI KARWASARA",
        Sdesignation:"Support Team Lead"
    },
    {
        id: "5",
        img: "/Images/Ourteam/team/paras.jpg",
         Sname:"Paras Pratap Singh",
        Sdesignation:"Implementation engineer"
    }
    ,
    {
        id: "6",
        img: "/Images/Ourteam/team/riddhima.jpg",
         Sname:"Riddhima Prakash",
        Sdesignation:"Graduate Engineer Trainee"
    }
]

export default products